<template>
  <footer class="footer text-center border-top border-dark">
    <div class="container footer-bottom clearfix">
      <div class="row">
        <div class="col-12 col-lg-6 text-start order-2 order-lg-1">
          © Copyright <strong><span>jcobinformation</span></strong>. All Rights Reserved
        </div>
        <div class="col-12 col-lg-6 text-start text-lg-end order-1 order-lg-2">
          <a href="http://www.jcobinfo.com" target="_black">회사소개</a>
          <span class="text-style-1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <router-link to="/home/stplatSrv">약관 및 정책</router-link>

<!--          <router-link to="/home/terSrv">이용약관</router-link>-->
<!--&lt;!&ndash;          <a href="/home/terSrv">이용약관</a>&ndash;&gt;-->
<!--          <span class="text-style-1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>-->
<!--          <router-link to="/home/privcySrv">개인정보처리방침</router-link>-->
<!--&lt;!&ndash;          <a href="/home/privcySrv">개인정보처리방침</a>&ndash;&gt;-->
<!--&lt;!&ndash;          <span class="text-style-1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>&ndash;&gt;-->
<!--&lt;!&ndash;          <a href="#service">서비스 문의</a>&ndash;&gt;-->
<!--          <span class="text-style-1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>-->
<!--          <router-link to="/home/locSrv">위치기반 서비스</router-link>-->
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6 text-start">
          <span>사업자등록번호: 374-81-00172</span>&nbsp;<span>통신판매업신고: 2023-서울영등포-0385</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6 text-start">
          <span>제이콥정보㈜ 대표이사 이기환</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6 text-start">
          <span>주소: (08595) 서울특별시 금천구 범안로 1130</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6 text-start">
          <span>전화번호 : 02-719-9940 이메일 : service@jcobinfo.com</span>
        </div>
        <!-- div class="col-12 col-lg-6 text-start text-lg-end">
            Cloud &amp; DevOps by <a href="https://www.quantumcns.ai/" target="_blank" class="fw-bold">Quantum C&amp;S</a>
        </div -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style scoped>
</style>